import { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Trophy } from "lucide-react";

export default function ComparisonTab({ id }) {
  const [lb, setLb] = useState(null);
  const [best, setBest] = useState("");
  useEffect(() => {
    const load = () => endpoints.leaderboard(id).then((r) => {
      setLb(r.data.leaderboard);
      setBest(r.data.best_model);
    });
    load();
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [id]);

  if (!lb || lb.length === 0) return <div className="text-sm text-muted-foreground">Leaderboard populates as models finish training…</div>;

  return (
    <div className="space-y-6">
      <div className="border border-border rounded-sm overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-secondary/40">
              <TableHead className="text-xs w-12">#</TableHead>
              <TableHead className="text-xs">Model</TableHead>
              <TableHead className="text-xs">Primary metric</TableHead>
              <TableHead className="text-xs text-right">Score</TableHead>
              <TableHead className="text-xs text-right">CV Score</TableHead>
              <TableHead className="text-xs text-right">Time</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {lb.map((row, i) => {
              const winner = row.model === best;
              return (
                <TableRow key={row.model} data-testid={`leaderboard-row-${row.model}`} className={winner ? "bg-accent/5" : ""}>
                  <TableCell className="num text-xs">{i + 1}</TableCell>
                  <TableCell className="text-sm font-medium flex items-center gap-2">
                    {winner && <Trophy className="w-3.5 h-3.5 text-accent" />}
                    <span className={winner ? "text-accent" : ""}>{row.model}</span>
                  </TableCell>
                  <TableCell className="text-xs font-mono text-muted-foreground">{row.primary_metric}</TableCell>
                  <TableCell className="num text-sm text-right font-semibold">{row.score.toFixed(4)}</TableCell>
                  <TableCell className="num text-xs text-right text-muted-foreground">{row.cv_score !== null ? row.cv_score.toFixed(4) : "—"}</TableCell>
                  <TableCell className="num text-xs text-right text-muted-foreground">{row.training_time_s}s</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>

      <div>
        <div className="label-mono mb-3">// FULL METRICS</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {lb.map((row) => (
            <div key={row.model} className="border border-border rounded-sm p-4 bg-card">
              <div className="flex items-center justify-between mb-3">
                <div className="font-display font-semibold">{row.model}</div>
                <div className="label-mono">{row.training_time_s}s</div>
              </div>
              <div className="grid grid-cols-2 gap-x-4 gap-y-1.5">
                {Object.entries(row.metrics).map(([k, v]) => (
                  <div key={k} className="flex justify-between text-xs">
                    <span className="text-muted-foreground font-mono uppercase">{k}</span>
                    <span className="num font-medium">{typeof v === "number" ? v.toFixed(4) : v}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
